import * as React from 'react';
import loadingImg from './img/loading.gif';

interface IProps
{
    show: boolean;
}

const Loading = (props: IProps) =>
    <div style={{
        display: props.show ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.5)",
        zIndex: 2
    }}>
        <img
            style={{
                width: "80px",
                height: "80px"
            }}
            src={loadingImg}
        />
    </div>

export default Loading;